import styled from "styled-components";

const Item = styled.div`
  width: 100%;
  height: 28px;
  padding: 0px 15px;
  box-sizing: border-box;

  border-radius: 14px;
  background: ${(props) => (props.selected ? "#3e5265" : "transparent")};

  transition: 0.2s;

  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: ${(props) => (props.justify ? props.justify : "flex-start")};

  &:hover {
    background: #3e5265;
    cursor: pointer;
  }
`;

const ItemIcon = styled.div`
  width: 18px;
  min-width: 18px;
  height: 18px;
  box-sizing: border-box;

  background-image: url(${(props) => props.icon});
  background-repeat: no-repeat;
  background-size: cover;
`;

const ItemText = styled.div`
  font-size: 13px;
  letter-spacing: 0.2px;
  white-space: nowrap;
`;

export default ({ icon, children, onClick, alignItems, selected }) => {
  return (
    <Item onClick={onClick} justify={alignItems} selected={selected}>
      {icon && <ItemIcon icon={icon} />}
      <ItemText>{children}</ItemText>
    </Item>
  );
};
